import theme from '../theme'
import {
  createStyles,
  withStyles,
  Theme,
  makeStyles,
} from '@material-ui/core/styles'
import { TableCell } from '@material-ui/core'

export const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.common.black,
      borderBottomColor: theme.palette.grey[900],
    },
    body: {
      fontSize: theme.typography.fontSize + 1,
      paddingBottom: '2px',
      paddingTop: '2px',
    },
  })
)(TableCell)

const styleOverride = makeStyles({
  headerRow: {
    backgroundColor: theme.palette.grey.A700,
  },
  columnName: {
    color: '#FFFFFF',
    width: '6rem',
  },
  mainCheckboxContainer: {
    '& span:first-child': {
      color: '#FFFFFF',
    },
  },
  checkboxContainer: {
    '& span:first-child': {
      color: theme.palette.grey[900],
    },
  },
  chipContainer: {
    '& .MuiChip-root': {
      border: '1px solid',
      backgroundColor: '#FFFFFF',
      borderColor: 'black',
      fontSize: theme.typography.fontSize + 1,
    },
  },
  //TODO: This colors needs to be added to theme
  activeStatus: {
    '& .MuiChip-root': {
      border: '1px solid',
      backgroundColor: '#F2FFF7',
      borderColor: '#008330',
      color: '#008330',
      fontWeight: theme.typography.fontWeightMedium,
    },
  },
  //TODO: This colors needs to be added to theme
  pendingStatus: {
    '& .MuiChip-root': {
      border: '1px solid',
      backgroundColor: '#E9EDFA',
      borderColor: '#5B73BA',
      color: '#5B73BA',
      fontWeight: theme.typography.fontWeightMedium,
    },
  },
})
export default styleOverride
